
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

import { ShopDonate } from '../../lib/models/ShopDonate'
import { Team } from '../../lib/models/Team'
import { RallyRound } from '../../lib/models/RallyRound'
import { ShopDonateOrder } from '../../lib/models/ShopDonateOrder'

import BacButton from '@/components/BacButton.vue'
import BacTable from '@/components/BacTable.vue'
import { Rally } from '../../lib/models/Rally'
import { Http } from '@/lib/utils/Http'
import { SerializationHelper } from '../../lib/utils/SerializationHelper'

import sanitizeHtml from 'sanitize-html'

@Component({
  components: {
    BacButton,
    BacTable
  }
})
export default class Charity extends Vue {
  @Prop({ required: true }) team!: Team;
  @Prop({ required: true }) rally!: Rally;
  @Prop({ required: true }) rallyRound!: RallyRound;
  @Prop({ required: true }) editMode!: boolean;

  teamCharitySum = 0;
  charitySum = 0;
  charities: ShopDonate[] = [];
  selectedCharityId = 0;
  teamDonations: ShopDonateOrder[] = []

  headers = [
    { text: 'Betrag', value: 'amount', width: '15%', sortable: false },
    { text: 'Spender', value: 'donater', width: '15%', sortable: false, sanitize: true },
    { text: 'Projekt', value: 'project', width: '35%', sortable: false },
    { text: 'Nachricht', value: 'message', width: '35%', sortable: false, sanitize: true }
  ]

  get items () {
    return this.teamDonations.map(teamDonation => {
      const charity = this.charities.find(charity => charity.id === teamDonation.shopDonateId)
      return {
        amount: teamDonation.price + '€',
        donater: teamDonation.companyName ? sanitizeHtml(teamDonation.companyName) : sanitizeHtml(teamDonation.donatorFirstName),
        project: charity ? charity.name : '',
        message: sanitizeHtml(teamDonation.message ? teamDonation.message : '-')
      }
    })
  }

  get chosenCharity (): ShopDonate {
    if (this.selectedCharityId) {
      return this.getCharityById(this.selectedCharityId)
    } else if (this.team.charityId) {
      return this.getCharityById(this.team.charityId)
    } else if (this.rallyRound.shopDonateId) {
      return this.getCharityById(this.rallyRound.shopDonateId)
    } else {
      return new ShopDonate()
    }
  }

  get memberTypeName (): string {
    if (!this.$store.state.PageURLTeam.team || !this.rally) {
      return 'Unser Team hat'
    }
    return this.$store.state.PageURLTeam.team.members.length <= 1
      ? this.rally.memberTypeHasName.singular
      : this.rally.memberTypeHasName.plural
  }

  getCharityById (id: number): ShopDonate {
    const charity = this.charities.find((charity) => charity.id === id)
    if (charity) {
      return charity
    }
    return new ShopDonate()
  }

  @Watch('team')
  onTeamChange () {
    if (this.team.charityId) {
      this.selectedCharityId = this.team.charityId
    }
    this.loadTeamCharitySum()
    this.selectedCharityId = this.chosenCharity.id
  }

  @Watch('rallyRound')
  onRallyRoundChange () {
    this.loadCharitySum()
    this.selectedCharityId = this.chosenCharity.id
  }

  @Watch('selectedCharityId')
  onSelectedCharityIdChange () {
    this.team.charityId = this.selectedCharityId
    this.team.update()
  }

  mounted () {
    this.loadCharities()
    this.loadCharitySum()
    this.loadDonations()
  }

  @Watch('team')
  async loadDonations () {
    if (!this.team.id) {
      return
    }
    const res = await Http.request(`/api/team/${this.team.id}/donations`)
    if (!res.ok) {
      return
    }

    this.teamDonations = SerializationHelper.toInstanceArray(ShopDonateOrder, await res.json())
  }

  forwardToMoreInfo () {
    (this.$refs.moreInfoLink as HTMLAnchorElement).click()
  }

  async loadTeamCharitySum () {
    if (!this.team.id) {
      return
    }

    let sum = (this.teamCharitySum = (
      await (await Http.request('/api/donate-team-sum/' + this.team.id)).json()
    ).sum)
    if (!sum) {
      this.teamCharitySum = 0
      return
    }
    sum = Math.round(sum * 100) / 100

    this.teamCharitySum = sum
  }

  @Watch('chosenCharity')
  async loadCharitySum () {
    if (!this.chosenCharity.id) {
      return
    }
    const charitySum = (
      await (
        await Http.request(`/api/donate-order-sum/${this.chosenCharity.id}`)
      ).json()
    ).sum

    this.charitySum = Math.round(charitySum * 100) / 100
  }

  async loadCharities () {
    this.charities = await ShopDonate.getAll({})
  }
}
